import { createMiddleware } from '@shared/redux';
import { setModalSelectedGroup, setSelectedGroupBySlug } from '@domain/segments';
import { getClusters } from '@domain/dashboard/cluster/cluster.state';
import { State } from '@domain/dashboard/budget-manager/budget-manager.types';
import { showSuccessToast, showWarningToast } from '@shared/toasts';
import { BUDGET_MANAGER_TEXTS } from '@domain/dashboard/budget-manager/budget-manager.constants';
import { trackOnRudderStack } from '@domain/analytics';
import {
    SAVE_CLUSTER_CONFIG_REQUEST_FAILED,
    SAVE_CLUSTER_CONFIG_REQUEST_SUCCEEDED,
    toggleVisibilityBudgetManagerModal,
    SaveClusterConfigRequestSucceeded,
} from '@domain/dashboard/budget-manager/budget-manager.state';
import { updateTaggedCampaigns } from './budget-manager.utils';
import { updateCampaignsItems } from '../campaigns/campaigns.state';

export const budgetManagerMiddleware = createMiddleware({
    [SAVE_CLUSTER_CONFIG_REQUEST_SUCCEEDED]: (
        state: State,
        action: SaveClusterConfigRequestSucceeded,
    ) => [
        setModalSelectedGroup({ group: action.payload.data }),
        setSelectedGroupBySlug({ groupSlug: action.payload.data.slug }),
        getClusters({ tagGroupId: action.payload.data.id }),
        updateCampaignsItems(
            {
                campaigns: updateTaggedCampaigns(
                    state.dashboard.campaigns.data,
                    state.dashboard.budgetManager.clusterConfig.data,
                ),
            },
        ),
        showSuccessToast({ message: BUDGET_MANAGER_TEXTS.CLUSTERS_SAVED_SUCCESSFULLY }),
        toggleVisibilityBudgetManagerModal(false),
        trackOnRudderStack('bbm_save_cluster', { outcome: 'SUCCEEDED' }),
    ],
    [SAVE_CLUSTER_CONFIG_REQUEST_FAILED]: () => [
        showWarningToast({ message: BUDGET_MANAGER_TEXTS.CLUSTERS_FAILED_TO_SAVE }),
        trackOnRudderStack('bbm_save_cluster', { outcome: 'FAILED' }),
    ],
});
